<template>
  <v-card flat class="settings-card">
    <v-container>
      <graph-and-grid
        Title="Message Log"
        DisplayingText="texts"
        :Headers="headers"
        ApiPath="/reporting"
        :SearchLocal="true"
        GetParamType="sms"
        GetParamName="log"
        GetParamSearchName="search_log"
      >
      </graph-and-grid>
    </v-container>
  </v-card>
</template>

<script>
import GraphAndGrid from "../../reports/shared/GraphAndGrid.vue";

export default {
  name: "SMSLog",
  components: {
    GraphAndGrid
  },
  directives: {},
  data: function() {
    return {
      headers: [
        {
          text: "Start Time",
          value: "startTime",
          width: "20%"
        },
        {
          text: "From",
          value: "from",
          width: "20%"
        },
        {
          text: "To",
          value: "to",
          width: "20%"
        },
        {
          text: "Message",
          value: "messageBody",
          width: "39%"
        },
        {
          text: "Action",
          value: "action",
          width: "1%"
        }
      ]
    };
  },
  computed: {},
  async created() {},
  methods: {},
  watch: {}
};
</script>

<style scoped lang="stylus"></style>
